import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardWidgets } from 'dashboard/enums/dashboard-widget.enum';
import { DashboardWidgetConfigurationInterface } from 'dashboard/interfaces/dashboard-widget-configuration.interface';

@Component({
    selector: 'app-list-style-dashboard-widget',
    templateUrl: './list-style-dashboard-widget.component.html',
    styleUrls: ['./list-style-dashboard-widget.component.scss', '../dashboard/dashboard.component.scss'],
    standalone: false,
})
export class ListStyleDashboardWidgetComponent {
    @Input() dashboardWidgetConfiguration: DashboardWidgetConfigurationInterface | undefined;

    constructor(private router: Router) {}

    onListItemClick(value: any) {
        if (this.dashboardWidgetConfiguration) {
            if (
                this.dashboardWidgetConfiguration?.dashboardWidget &&
                [DashboardWidgets.LISTINGS_WITHOUT_UPDATES].indexOf(this.dashboardWidgetConfiguration?.dashboardWidget) > -1
            ) {
                this.router.navigate(['listings/details', value, 'listingProfile']);
            }
        }
    }
}
